export default __webpack_public_path__ + "static/media/changePeople.c9236461.png";